import '@ezugi/polyfills.js';
import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import {
  GAME_ID_FROM_URL,
  ROULETTE_AUTOMATED_ID,
  ROULETTE_REVOLUTION_ID,
  ROULETTE_REVOLUTION_US_ID,
  ROULETTE_RNG_ID,
  ROULETTE_ULTIMATE_ID,
  TRIPLE_ZERO_ROULETTE_ID,
} from '@ezugi/constants';

const Roulette = lazy(() => import('./Roulette'));
const UltimateRoulette = lazy(() => import('./UltimateRoulette'));
const AutomatedRoulette = lazy(() => import('./AutomatedRoulette'));
const RNGRoulette = lazy(() => import('./RNGRoulette'));
const RevolutionRoulette = lazy(() => import('./RevolutionRoulette'));
const TripleZeroRoulette = lazy(() => import('./TripleZeroRoulette'));

const getGameVariant = () => {
  switch (GAME_ID_FROM_URL) {
  case ROULETTE_ULTIMATE_ID:
    return UltimateRoulette;
  case ROULETTE_AUTOMATED_ID:
    return AutomatedRoulette;
  case ROULETTE_RNG_ID:
    return RNGRoulette;
  case ROULETTE_REVOLUTION_ID:
    return RevolutionRoulette;
  case ROULETTE_REVOLUTION_US_ID:
    return RevolutionRoulette;
  case TRIPLE_ZERO_ROULETTE_ID:
    return TripleZeroRoulette;
  default:
    return Roulette;
  }
};

const rootElement = document.getElementById('root') as HTMLDivElement;
const root = createRoot(rootElement);

const RouletteGame = getGameVariant();

root.render(
  <Suspense>
    <RouletteGame />
  </Suspense>
);
